import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import { injectReadableIds } from 'tools/product'
import { updateForAsyncRequest, updateForAsyncSuccess, updateForAsyncFailure } from '@jarvis.oddle/core/tools/redux/reducer'
import * as C from './constants'

export const initialState = createAsyncObject([])

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case C.GET_MENU_REQUEST: updateForAsyncRequest(draftState); break
    case C.GET_MENU_SUCCESS: updateForAsyncSuccess(injectReadableIds(action.payload.tags))(draftState); break
    case C.GET_MENU_FAILURE: updateForAsyncFailure(action)(draftState); break
  }
})
